// Function to generate dynamic lineChartData
export const generateLineChartData = (revenueData, profitData) => {
  return [
    {
      
      name: "Tokens",
      data: revenueData,
      color: "#2563eb",
    },
  ];
};

// Function to generate dynamic lineChartOptions
export const generateLineChartOptions = (categories) => {
  return {
    legend: {
      show: false,
    },
    theme: {
      mode: "light",
    },
    chart: {
      type: "line",
      toolbar: {
        show: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "straight",
      type: "line",
    },
    tooltip: {
      style: {
        fontSize: "12px",
        fontFamily: undefined,
        backgroundColor: "#000000",
      },
      theme: "dark",
      x: {
        format: "dd/MM/yy HH:mm",
      },
    },
    grid: {
      show: true,
      strokeDashArray: 5,
      yaxis: {
        lines: {
          show: true,
        },
      },
      xaxis: {
        lines: {
          show: false,
        },
      },
      row: {
        colors: ["#f3f3f3", "transparent"],
        opacity: 0.5,
      },
    },
    xaxis: {
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      labels: {
        style: {
          colors: "#A3AED0",
          fontSize: "12px",
          fontWeight: "500",
        },
        formatter: function(value) {
          // Format date to show only day (DD)
          if (value) {
            const date = new Date(value);
            return date.getDate().toString().padStart(2, '0');
          }
          return value;
        }
      },
      type: "text",
      range: undefined,
      categories: categories,
      title: {
        text: `${new Date().toLocaleString('default', { month: 'long' })} ${new Date().getFullYear()}`,
        style: {
          color: "#000",
          fontSize: "14px",
          fontWeight: "bold",
        },
      },
    },
    yaxis: {
      show: true,
      tickAmount: 4,
      max: 100,
      labels: {
        formatter: function (value) {
          return value.toFixed(0);
        },
      },
    },
  };
};

// Example of dynamic data
const dynamicRevenueData = [0, 4, 3, 0, 0, 4,2,0,4,3,0,4,4,3,3,0,0,0,0,0,2,2,2,1,3,3,0,4,2,1,];
const dynamicProfitData = [30, 40, 24, 46, 20, 46];
const dynamicCategories = [1, 2, 3, 4, 5, 6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30];

export const lineChartDataTotalSpent = generateLineChartData(
  dynamicRevenueData,
  dynamicProfitData
);
export const lineChartOptionsTotalSpent =
  generateLineChartOptions(dynamicCategories);
